<template>
    <div id="banner-section">
        <b-modal size="lg" @hide="onHide" id="banner-modal" ref="bannerModal" centered hide-header hide-footer>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="banner mx-auto">
                            <div class="banner-content">
                                <div class="d-flex justify-content-center">
                                    <CampSuccessIcon/>
                                </div>
                                <div class="mt-5">
                                    <p class="h4b c7 text-center">Hurray! You are all set!</p>
                                </div>
                                <div class="mt-4">
                                    <p class="text-center c23 p1n mb-0">Post the banner and  the link on your campaign page and  be the part of</p>
                                    <p class="text-center c23 p1n">the homepage shuffle! Increase your visibility and crossprom deals! </p>
                                </div>
                            </div>
                            <div class="banner-wrap">
                                <div class="d-flex justify-content-center position-relative">
                                    <div class="download-icon position-absolute">
                                        <DownloadImgIcon id="download-img-btn" @click.native="download(bannerSrc)"/>
                                    </div>
                                    <img id="banner-img" :src="bannerSrc" alt="">
                                </div>
                                <div class="link-input d-flex justify-content-center mt-3">
                                    <input 
                                        id="project-url"
                                        type="text" 
                                        disabled 
                                        :value="projectUrl">
                                    <a-tooltip>
                                        <template v-if="copied" slot="title">
                                            Copied
                                        </template>
                                        <template v-else slot="title">
                                            Copy
                                        </template>
                                        <button id="copy-btn" class="p-0">
                                            <CopyIcon type="banner" @click.native="copyTextToClipboard(projectUrl)"/>
                                        </button>
                                    </a-tooltip>
                                </div>
                            </div>
                            <div class="banner-footer my-4 d-flex justify-content-center">
                                <Button id="done-btn" @click.native="onHide" type="primary_outline">
                                    DONE
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Button from '../components/Theme/Button'
import { CampSuccessIcon, CopyIcon, DownloadImgIcon } from '../components/Icons' 
export default {
    name: 'BannerModal',
    components: {
        CampSuccessIcon,
        DownloadImgIcon,
        CopyIcon,
        Button
    },
    props: [
        'projectUrl'
    ],
    data: function() {
        return {
            copied: false,
            bannerSrc: 'https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2Fbanner.jpg?alt=media&token=d23dfc03-3e2c-4775-be70-7e1df69d7d52'
        }
    },
    methods: {
        onHide: function (evt) {
            this.$bvModal.hide('banner-modal')
        },
        copyTextToClipboard: function(text) {
            let el = document.createElement('input')  
            el.value = text
            document.body.appendChild(el)
            el.select()
            el.focus()
            document.execCommand('copy')
            document.body.removeChild(el)  
            this.copied = true  
            setTimeout(() => {
                this.copied = false 
            }, 2000);

            this.$ga.event('Banner Modal', 'Copy link', 'Location', 'Add Wizard')
            this.$sendMixpanelEvent('Banner modal copy link clicked', {
                'Banner Location': 'Add Wizard'
            });
        },
        download: function (url) {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const image = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = image
                    link.download = 'crossprom-banner.jpg'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })

            this.$ga.event('Banner Modal', 'Download Pic', 'Location', 'Add Wizard')
            this.$sendMixpanelEvent('Banner modal download clicked', {
                'Banner Location': 'Add Wizard'
            })
        },
    }
}
</script>

<style scoped lang="scss">
div.banner {
    width: 720px;
    height: 600px;
    background: #FFFFFF;
    border-radius: 5px;

    div.banner-content {
        width: 540px;
        margin: 0 auto;
        padding-top: 24px;
    }

    div.banner-wrap {
        height: 248px;
        background: #F4F4F4;
        padding-top: 16px;
        
        div.download-icon {
            right: 24px;
            top: 8px;
        }
        div.link-input {
            padding-left: 16px;
            padding-right: 16px;
            input {
                width: 100%;
                height: 33px;
                padding-left: 10px;
                background: #FFFFFF;
                border: 1px solid #727CF5;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                font-size: 12px;
                color: #333333;
            }
        }

    }
    div.banner-footer {
        button {
            padding: 12px 102px;
            font-size: 13px !important;
            font-weight: bold !important;
        }
    }
}
</style>